/**
 * @Author: Li, Yu Jia
 * @Date: 2020-04-10 15:25:01
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-09-11 09:25:47
 */

import { getHostVendorDict, getVendorDict } from '../../logics';

import React from 'react';
import { getCustomerServiceNumber } from '../../selectors';
import styles from './ServiceNumber.scss';
import { useSelector } from 'react-redux';

const ServiceNumber = () => {
  const serviceNumber =
    useSelector(getCustomerServiceNumber) || getVendorDict('csNumber') || getHostVendorDict('csNumber');
  return (
    <>
      {serviceNumber && serviceNumber.length > 0 && (
        <span className={styles['main-servicenumber']}>{serviceNumber}</span>
      )}
    </>
  );
};

export default ServiceNumber;
